import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "../../Services/auth.service";
import {
  alertSnackbarError,
  alertSnackbarSuccess,
  setAlertError,
} from "./alertStatusSlice";
import errorSlice from "../../Services/errorSlice";
import { TOKEN, TOKEN_EXP, USER, USER_GROUP } from "../../Config";

const initialState = {
  loading: false,
  result: null,
  isLoggedIn: false,

  updatePasswordLoading: false,
  updatePasswordMsg: null,

  updatePasswordMailLoading: false,
  updatePasswordMailMsg: null,

  opdLoading: false,
  opdResult: null,
  opdIsLoggedIn: false,
};

export const login = createAsyncThunk(
  "auth/login",
  async (values, thunkAPI) => {
    try {
      const data = await authService.login(values);
      const job = new Promise((resolve, reject) => {
        if (data.status === true) {
          resolve(data);
        } else {
          reject(data);
        }
      });
      return await job;
    } catch (error) {
      if (error.response) {
        errorSlice.error(error, thunkAPI);
      } else {
        thunkAPI.dispatch(setAlertError(error));
        return thunkAPI.rejectWithValue();
      }
    }
  }
);
export const loginLine = createAsyncThunk(
  "auth/loginLine",
  async (values, thunkAPI) => {
    try {
      if (values) {
        thunkAPI.dispatch(alertSnackbarSuccess("Login Successfully"));
      } else {
        thunkAPI.dispatch(alertSnackbarError("Login Fail"));
      }
      localStorage.setItem(TOKEN, values.token);
      localStorage.setItem(TOKEN_EXP, new Date());
      localStorage.setItem(USER, JSON.stringify({ user: values.user }));
      localStorage.setItem(USER_GROUP, JSON.stringify(values.users_group));
      return values;
    } catch (error) {
      if (error.response) {
        errorSlice.error(error, thunkAPI);
      } else {
        thunkAPI.dispatch(setAlertError(error));
        return thunkAPI.rejectWithValue();
      }
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async (thunkAPI) => {
  try {
    authService.logout();
    window.location.reload();
  } catch (error) {
    errorSlice.error(error, thunkAPI);
  }
});

export const reloadPage = createAsyncThunk("auth/reload", (thunkAPI) => {
  try {
    const isAuth = authService.reloadPage();
    return isAuth;
  } catch (error) {
    errorSlice.error(error, thunkAPI);
  }
});

export const update_password = createAsyncThunk(
  "auth/update_password",
  (values, thunkAPI) => {
    try {
      let api = authService.update_password(values);
      const isAuth = api.then((response) => {
        const { data } = response;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return isAuth;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const update_password_send_email = createAsyncThunk(
  "auth/update_password_send_email",
  (values, thunkAPI) => {
    try {
      const isAuth = authService
        .send_email_update_password(values)
        .then((response) => {
          const { data } = response;
          if (data.status === true) {
            thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
          } else {
            thunkAPI.dispatch(alertSnackbarError(data.msg));
          }
          return data;
        });
      return isAuth;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const authSlice = createSlice({
  name: "authSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state, action) => {
      state.loading = true;
      state.isLoggedIn = false;
      state.result = null;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.result = action.payload;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.result = action.payload;
    });
    builder.addCase(loginLine.pending, (state, action) => {
      state.loading = true;
      state.isLoggedIn = false;
      state.result = null;
    });
    builder.addCase(loginLine.fulfilled, (state, action) => {
      state.loading = false;
      state.isLoggedIn = true;
      state.result = action.payload;
    });
    builder.addCase(loginLine.rejected, (state, action) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.result = action.payload;
    });
    builder.addCase(logout.fulfilled, (state, action) => {
      state.loading = false;
      state.isLoggedIn = false;
      state.result = null;
    });
    builder.addCase(reloadPage.fulfilled, (state, action) => {
      state.loading = false;
      state.isLoggedIn = action.payload;
      state.result = JSON.parse(localStorage.getItem("user"));
    });

    builder.addCase(update_password.pending, (state, action) => {
      state.updatePasswordLoading = true;
      state.updatePasswordMsg = null;
    });
    builder.addCase(update_password.fulfilled, (state, action) => {
      state.updatePasswordLoading = false;
      state.updatePasswordMsg = action.payload;
    });
    builder.addCase(update_password.rejected, (state, action) => {
      state.updatePasswordLoading = false;
      state.updatePasswordMsg = null;
    });

    builder.addCase(update_password_send_email.pending, (state, action) => {
      state.updatePasswordMailLoading = true;
      state.updatePasswordMailMsg = null;
    });
    builder.addCase(update_password_send_email.fulfilled, (state, action) => {
      state.updatePasswordMailLoading = false;
      state.updatePasswordMailMsg = action.payload;
    });
    builder.addCase(update_password_send_email.rejected, (state, action) => {
      state.updatePasswordMailLoading = false;
      state.updatePasswordMailMsg = null;
    });
  },
});

export const { reducer } = authSlice.actions;

export default authSlice.reducer;
